import FullSizeImageTextBlock from "./full-size-image-text-block";

export default FullSizeImageTextBlock